import { createSlice } from "@reduxjs/toolkit";

const initialSateValue = {
    modal: false,
};

export const counselingSlice = createSlice({
    name: "question",
    initialState: {
        value: initialSateValue,
    },
    reducers: {
        openQuestion: (state, action) => {
            state.value = {modal: true};
        },
        closeQuestion: (state, action) => {
            state.value = { modal: false };
        },
    },
});

export const { openQuestion, closeQuestion } = counselingSlice.actions;

export default counselingSlice.reducer;
